import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'activityLog';

const activityLogService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },
};

export default activityLogService;
